import { useEffect } from "react";

/** Add a noindex robots meta while this page is mounted, and remove that node on unmount. */
export default function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex,nofollow");
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);
}
